<div *ngIf="item" class="container-fluid" style="padding: 50px 80px">
    <div class="row">
        <div class="col-12 col-lg-6">
            <img [src]="item.imageUrl" class="img-fluid" />
        </div>
        <div class="col-12 col-lg-6">
            <p class="text-16 ff-spectral strong">Meet the Team</p>
            <h1 class="ff-spectral">{{item.name}}</h1>
            <p class="text-12 op-6">{{item.jobTitle}}</p>
            <div class="mt-50" [innerHTML]="item.content"></div>
        </div>
    </div>
</div>
<div class="container-fluid staff-contact">
    <div class="row">
        <div class="col-6">
            <p class="mb-3 text-16 ff-spectral">Email</p>
            <p class="mb-0 text-26 ff-spectral">{{item.email}}</p>
        </div>
        <div class="col-6">
            <p class="mb-3 text-16 ff-spectral">Telephone</p>
            <p class="mb-0 text-26 ff-spectral">{{item.landline}}</p>
        </div>
    </div>
</div>

<div class="container-fluid mt-50">
    <!--<app-meet-the-team [backgroundColour]="'bg-white'" [containerPadding]="20"></app-meet-the-team>-->
</div>
